import React, { useState, useCallback } from "react";
import MaterialTable from "@material-table/core";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Edit as EditIcon, CheckBox as CheckBoxIcon, ExitToApp as RegisterIcon } from "@mui/icons-material";
//import CheckBoxIcon from "@mui/icons-material/CheckBox";
//import Alert from "@mui/material/Alert";
import ParticipantUpdateModal from "./participantUpdateModal";
import ParticipantIceModal from "./participantIceModal";
import ParticipantCapnr from "./participantCapnr";
//import ParticipantDistance from "./participantDistance";
import appTheme from "../appTheme"
import { ThemeProvider } from "@mui/material/styles"
import { CircularProgress, Backdrop, Typography } from "@mui/material";
import { nlStatus } from "./helperFunctions";
import AlertDialog from './alertDialog';
import { orderBy } from 'natural-orderby';


const ParticipantList = ({ participants, registerActor, patchParticipant, resetParticipant, wavesData}) => {

  const [participant, setParticipant] = useState(null);
  const [iceParticipant, setIceParticipant] = useState(null);

  const [showICEAlert, setICEShowAlert] = useState(false);

  const [isWaiting, setIsWaiting] = useState(false);
  const [showCapDialog, setShowCapDialog] = useState({
    capnr: "",
    id: ""
  })
  //const [showDistanceDialog, setShowDistanceDialog] = useState({
  //  distance: "",
  //  capnr: "",
  //  id: ""
  //})

  // Was the state changed? Update participant used for dialog
  if (participant) {
    const hlpParticipant = participants.find(item => item.participantId === participant.participantId);
    if (hlpParticipant.state !== participant.state) {
      setParticipant({
        ...participant,
        "state": hlpParticipant.state
      });
    }
  }

  const checkinActor = (selectedRow) => {
    console.log("Registering")
    console.log(selectedRow)
    let result = registerActor(selectedRow.capnr)
    if (result) {
      // This will be a promise, as the call will be handled by async call
      console.log("Received response from registering:")
      console.log(result)
    }
  }

  const closeDialog = () => {
    console.log("Closing participant popover dialog...")
    setParticipant(null);
  }

  const closeIceDialog = () => {
    console.log("Closing participant popover dialog...")
    setIceParticipant(null);
  }


  const setCapnr = async (capnr, canReuse) => {
    const oldCapnr = showCapDialog.capnr
    //console.log("Setting Capnr to " + capnr + " from " + oldCapnr)
    const response = await patchParticipant(showCapDialog.id, {"capnr": capnr, "reuseCapnr": canReuse, "oldCapnr": oldCapnr})
    //console.log(showCapDialog.id + " has been assigned to " + capnr)
    //console.log("patchParticipant - Response: ", response);
    const hlpParticipant = participants.find(item => item.participantId === participant.participantId);
    //console.log("Found participant in array: ", hlpParticipant);
    setParticipant({
      ...participant,
      "capnr": hlpParticipant.capnr
    });
    setShowCapDialog({ capnr: "", id: "" })
  }

  const close = () => {
    console.log("Closing without change")
    setShowCapDialog({ capnr: "", id: "" })
  }

  //const setDistance = async (distance) => {
  //  console.log("Setting distane to " + distance)
  //  setIsWaiting(true);
  //  const response = await patchParticipant(showDistanceDialog.id,  {"distance": distance})
  //  console.log("After response: ", showDistanceDialog.id + " has been changed to " + distance)
  //  console.log("Response:", response)
  //  setShowDistanceDialog({ distance: "", capnr: "", id: "" })
  //  setIsWaiting(false);
  //}

  //const closeDistance = () => {
  //  console.log("Closing distance withoug change")
  //  setShowDistanceDialog({ distance: "", capnr: "", id: "" })
  //}

  //const changeCapnr = async (selectedRow) => {
  //  // At this moment, the links section is missing in participant.
  //  // So added manually
  //  setShowCapDialog({ capnr: selectedRow.capnr, id: selectedRow.participantId })
  //  console.log("After Patching participant")
  //}

  //const changeDistance = async (selectedRow) => {
  //  // At this moment, the links section is missing in participant.
  //  // So added manually
  //  console.log("Changing Distance???");
  //  console.log(selectedRow);
  //  setShowDistanceDialog({ capnr: selectedRow.capnr, distance: selectedRow.distance, id: selectedRow.participantId })
  //  console.log("After Patching participant")
  //}

  const handleRegisterClick = (rowData) => {
    if (
      // participant is below 18
      rowData.age < 18 &&
      (
        // ICE first and last name need to be filled
        !rowData.iceFirstName || !rowData.iceLastName ||
          // and at least one of the phonenumbers need to be filled
          (!rowData.icePhone1 && !rowData.icePhone2)
      )
    )
    {
      // set an alert that this participant cannot register without proper ICE data
      setICEShowAlert(true)
    }
      else {
      // otherwise register this participant
        checkinActor(rowData)
      }
  };

  const registerButton = useCallback((rowData) => {
    return (
      <Button key="aanmeldButton" id={`ButtonRegister${rowData.capnr}`}
        variant="contained"
        color={rowData.state === "initial"? "secondary": "primary"}
        onClick={() => handleRegisterClick(rowData)}
        disabled={(rowData.state !== "initial")}
      >
      {rowData.state === "initial"? <RegisterIcon /> : <CheckBoxIcon />}
      </Button>);
  }, [participants]);

  const changeButton = useCallback((rowData) => {
    return (
      <Button key="participantId" id={`ButtonChange${rowData.displayCapnr}`}
        variant="contained"
        size="small"
        onClick={(e) => setParticipant(rowData) }
        disabled={(rowData.state === "busy" || rowData.state === "done" || rowData.state === "ready")}
        sx={{ textTransform: "capitalize" }}
      >
      <EditIcon fontSize="small"/>
      </Button>);
  }, [participants]);

  const iceButton = useCallback((rowData) => {
    return (
      <Button key="participantId" id={`ButtonChange${rowData.displayCapnr}`}
        variant="contained"
        size="small"
        onClick={(e) => setIceParticipant(rowData) }
        sx={{ textTransform: "capitalize" }}
      >
      ICE
      </Button>);
  }, [participants]);


  const dutchState = useCallback((rowData) => {
    return (
      <Typography key="NLState" id={`NLState${rowData.capnr}`}>
      {nlStatus(rowData.state)}
      </Typography>);
  }, [participants]);

  return (
    <ThemeProvider theme={appTheme}>
    <Box id="AanmeldenLijst" sx={{ mt: 1}}>
      <MaterialTable
        //icons={tableIcons}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} van {count}",
            labelRowsSelect: "Rijen",
            labelRowsPerPage: "Rijen per pagina:",
            firstAriaLabel: "Eerste pagina",
            firstTooltip: "Eerste pagina",
            previousAriaLabel: "Vorige pagina",
            previousTooltip: "Vorige pagina",
            nextAriaLabel: "Volgende pagina",
            nextTooltip: "Volgende pagina",
            lastAriaLabel: "Laatste pagina",
            lastTooltip: "Laatste pagina"
          },
          toolbar: {
            addRemoveColumns: "Verwijder of voeg kolommen toe",
            nRowsSelected: "{0} rij(en) geselecteerd",
            showColumnsTitle: "Toon kolommen",
            showColumnsAriaLabel: "Toon kolommen",
            exportTitle: "Export",
            exportAriaLabel: "Export",
            exportName: "Export als CSV",
            searchTooltip: "Zoeken",
            searchPlaceholder: "Zoeken"
            },
          header: {
              actions: "Aanmelden"
          },
          body: {
              emptyDataSourceMessage: "Er zijn geen resultaten",
              filterRow: {
                  filterTooltip: "Filter"
              }
          }
        }}
        options={{
          pageSize: 5,
          headerStyle: { position: "sticky", top: 0, fontWeight: "bold", color: "white", backgroundColor: "#019ce2" },
          rowStyle: (rowData) => ({
            backgroundColor:
              rowData.state !== "initial" ? "#f2fafd" :
                rowData.tableData.id % 2 === 0 ? "#D2EAEE" : "#E9F4F6",
            color:
              rowData.state !== "initial" ? "rgba(0, 0, 0, 0.38)" : "black"
          }),
          tableLayout: "fixed"
        }}
        title="Deelnemers"
        columns={[
          {
            title: "ID",
            field: "id",
            hidden: true,
            width: 0
          },
          {
            title: "ParticipantID",
            field: "participantId",
            hidden: true,
            width: 0
          },
          {
            title: "Cap",
            field: "capnr",
            hidden: true,
            width: 0
          },
          {
            title: "Aanmelden",
            field: "capnr",
            width: "9%",
            render: registerButton
          },
          {
            title: "Capnr",
            field: "displayCapnr",
            width: "6%",
            customSort: (a, b, type, direction) => {
              return parseInt(a["displayCapnr"].replace(/\D/g, '')) - parseInt(b["displayCapnr"].replace(/\D/g, ''));
            }
          },
          {
            title: "Status",
            field: "state",
            width: "11%",
            render: dutchState
          },
          {
            title: "Naam",
            field: "fullName",
            width: "15%"
          },
          {
            title: "Voornaam",
            field: "firstName",
            hidden: true,
            width: 0
          },
          {
            title: "Achternaam",
            field: "lastName",
            hidden: true,
            width: 0
          },
          {
            title: "Postcode",
            field: "zipcode",
            width: "9%"
          },
          {
            title: "Geb.datum",
            field: "birthday",
            width: "11%"
          },
          {
            title: "Leeftijd",
            field: "age",
            width: "7%",
            cellStyle: (value, rowData) => {
                return {
                    color: (rowData.state !== "initial" ? "rgba(0, 0, 0, 0.38)" : rowData.age < 18 ? "red" : "black"),
                    fontWeight: (rowData.state == "initial" && rowData.age < 18 ? "bold" : "normal")
                }
            }
          },
          {
            title: "Afstand",
            field: "distance",
            width: "7%"
          },
          {
            title: "Wave",
            field: "wave",
            width: "9%"
          },
          {
            title: "Team",
            field: "teamName",
            width: "12%"
          },
          //{ Disabled to make space for wave
          //  title: "Gewijzigd",
          //  field: "changedBy",
          //  width: "9%"
          //},
          {
            title: "Wijzigen",
            field: "state",
            width: "8%",
            render: changeButton
          },
          {
            title: "ICE",
            field: "capnr",
            width: "8%",
            render: iceButton
          },

        ]}
        data={participants}
      />
      {participant && <ParticipantUpdateModal participant={participant}
        registerActor={registerActor}
        allowResetAllStates={false}
        close={closeDialog}
        resetParticipant={resetParticipant}
        patchParticipant={patchParticipant}
        setShowCapDialog={setShowCapDialog}
        wavesData={wavesData}
        />}
      {iceParticipant && <ParticipantIceModal participant={iceParticipant}
        allowResetAllStates={false}
        close={closeIceDialog}
        />}

      {showCapDialog.capnr && <ParticipantCapnr name={participant.fullName} capnr={showCapDialog.capnr} setCapnr={setCapnr} close={close} setIsWaiting={setIsWaiting}/>}
      {/* <Backdrop
        sx={{ color: "#fff", zIndex: 99999 }}
        open={isWaiting}>
        <CircularProgress color="inherit" />
      </Backdrop> */}
       {showICEAlert && <AlertDialog
              onClose={() => setICEShowAlert(false)}
              // TODO: find where to place this message together with other messages
              message="De volgende ICE gegevens zijn verplicht voor een minderjarige deelnemer: voornaam, achternaam en minimaal één telefoonnummer. Vul de gegevens aan en probeer het opnieuw."
              severity="warning"
              />}
    </Box>
    </ThemeProvider>
  );
}

export default ParticipantList;
